import React, { forwardRef } from 'react';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

export const iconCircleHeight = 32;
export const iconCircleWidth = 32;

const useStyles = makeStyles()(theme => ({
  circle: {
    alignItems: 'center',
    backgroundColor: theme.appColors.defaultFieldBackground,
    borderRadius: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    height: iconCircleHeight,
    justifyContent: 'center',
    width: iconCircleWidth,
  },
}));

interface IconCircleProps extends React.HTMLAttributes<HTMLElement> {
  icon: React.ReactNode;
}

export const IconCircle = forwardRef(function IconCircle(
  { className, icon, ...rest }: IconCircleProps,
  ref: React.Ref<HTMLDivElement>
): JSX.Element {
  const { classes } = useStyles();

  return (
    <div ref={ref} className={clsx(classes.circle, className)} {...rest}>
      {icon}
    </div>
  );
});
